import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import headerLogo from "./Assets/Images/AMBRE-LETTERHEAD.png"

const root = ReactDOM.createRoot(document.getElementById('root'));
// window.owner_signatories = "ANGELO QUIBRANZA";
window.owner_signatories = "GWEN QUIBRANZA";
window.tenant_signatories = "GWEN QUIBRANZA";
window.system_title = "AMBRE Property Partners";
window.account1 = "BPI";
window.account2 = "Account Name: Nino Angelo Quibranza and/or Gwen Maria Feliz Javier";
window.account3 = "Account Number: 0209-0289-78";
window.account4 = "GCASH";
window.account5 = "Account Name: Gwen Maria Feliz Javier";
window.account6 = "Account Number: 0905-290-0089";
window.form_header = headerLogo;

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
